// Единые уведомления вместо нативных alert(): диспатчат событие app:toast,
// которое глобально слушается в App.js и рендерится темизированным тостом
// (в Nova — Sonner, в классике — свой тост). Типы: success | error | warning | info.
export const notify = (type, message) => {
    try {
        window.dispatchEvent(new CustomEvent('app:toast', { detail: { type, message } }));
    } catch (_) {
        // Крайний fallback, если CustomEvent недоступен
        // eslint-disable-next-line no-alert
        alert(message);
    }
};

export const notifySuccess = (message) => notify('success', message);
export const notifyError = (message) => notify('error', message);
export const notifyWarning = (message) => notify('warning', message);
export const notifyInfo = (message) => notify('info', message);
